<template>
  <div>
    <Head></Head>
    <Navbar activeMenu="相关制度" />
    <Banner></Banner>
    <div class="main">
      <div class="container">
        <div class="menu">
          <div
            v-for="item in menus"
            :key="item"
            class="menu-item"
            :class="{ 'menu-item_active': active === item }"
            @click="active = item"
          >
            {{ item }}
          </div>
        </div>
        <div class="content">
          <div class="title">
            <span v-if="active === '自审制度'">安徽科学技术出版社乐龄听书内容自审制度</span>
            <span v-else-if="active === '防沉迷'">安徽科学技术出版社乐龄听书防沉迷制度</span>
            <span v-else-if="active === '家长监护'">安徽科学技术出版社乐龄听书家长监护制度</span>
            <span v-else-if="active === '纠纷处理'">安徽科学技术出版社乐龄听书纠纷处理制度</span>
          </div>

          <div v-if="active === '自审制度'">
            <p class="paragraph">
              为规范我单位网文文化产品及服务内容的企业自审工作,明确我单位开展相关工作的职责、流程、标准以及责任追究办法。根据《网络文化经营单位内容自审管理办法》的相关要求特制订本制度
            </p>
            <p class="text-bold paragraph">1.1 机构设置</p>
            <p>
              自即日起成立独立于各个业务部门的内容审查委员会，委员包括开发小组的总经理或主策划、客服部经理以及市场运营部经理。由总经理负责委员会的召集和日常运作事宜。委员会的主要任务是在产品开发过程中规范相关内容;在版本验收环节对可能涉及违反法律法规的内容进行自查自纠；在运营过程中随时检查各种营销素材、活动及其他内容是否有不适当的内容出现。并且一旦发现有违规情况的发生，委员会负责对相关责任人和部门进行查处惩戒。
            </p>
            <p class="text-bold paragraph">1.2 日常运作</p>
            <p>
              委员会每周召集一次全体会议，就产品开发过程中的各个环节当中的内容来源、表现方式进行集中审查和讨论，每周在公司内公布违规内容自查结果,如没有违规内容则不公布。委员会委员有义务将最近工作过程中所开发的内容对其他委员进行公开展示，并接受质询。客服部经理将针对测试过程中出现的所有可能涉及违规的内容进行通告，并要求各部门限期整改。
            </p>
            <p class="text-bold paragraph">1.3 内部培训</p>
            <p>
              为确保及时准确的了解国家最新有关政策法规,由委员会召集定期对内部人员进行有关法规的讲解和培训，并进行考试。覆盖对象主要是内容编辑及各部门负责人。
            </p>
            <p>培训不定期举行，主要是针对最新出台的法规政策,以及新近升职上任的管理人员所进行。</p>
            <p class="text-bold paragraph">1.4 自审内容准则</p>
            <p>网络演出剧(节)目不得含有以下内容：</p>
            <p>(一)违反宪法确定的基本原则的；</p>
            <p>(二)危害国家统一、主权和领土完整的；</p>
            <p>(三)泄露国家秘密、 危害国家安全或者损害国家荣誉和利益的；</p>
            <p>(四)煽动民族仇恨、 民族歧视,破坏民族团结,或者侵害民族风俗、习惯的；</p>
            <p>(五)宣扬邪教、迷信的；</p>
            <p>(六)散布谣言,扰乱社会秩序，破坏社会稳定的；</p>
            <p>(七)宣扬淫秽、色情、赌博、暴力,或者教唆犯罪的；</p>
            <p>(八)侮辱、 诽谤他人，侵害他人合法权益的；</p>
            <p>(九)违背社会公德的；</p>
            <p>(十)有法律、行政法规和国家规定禁止的其他内容的。责任追究：</p>
            <p>明确内部对审核人员、开发人员及运营人员的内容审核责任追究规定。</p>
            <p>对审核人员未能在审核过程中发现问题的，予以口头警告；</p>
            <p>对审核人员发现问题,但开发人员拒不修改的，予以书面警告；</p>
            <p>对审核人员发现问题,但开发人员修改，审核通过后自行予以回复的，予以扣除当月奖金；</p>
            <p>
              对运营人员在运营过程中未通知审核人员,造成不良后果，而审核人员也未及时发现的，予以扣除当月奖金，累积满三次运营人员予以调离岗位，审核人员予以取消审核资格并调离岗位；
            </p>
            <p>其他造成不良后果情形的，予以书面警告。</p>
            <p class="text-bold paragraph">1.5 自审机构人员名单</p>
            <table
              border
              class="paragraph"
            >
              <thead>
                <td class="text-bold">自审人员</td>
                <td class="text-bold">工作职责</td>
              </thead>
              <tbody>
                <tr>
                  <td>蔡琴凤、刘霖、李听听</td>
                  <td>初审人员</td>
                </tr>
                <tr>
                  <td>钱湘林</td>
                  <td>复审人员</td>
                </tr>
                <tr>
                  <td>陈 军</td>
                  <td>终审人员</td>
                </tr>
              </tbody>
            </table>
            <p class="text-bold paragraph">1.6 审核流程</p>
            <p>
              我单位按照《网络文化经营单位内容自审管理办法》规定，建立自审管理制度,对网络文化产品及服务内容进行事前审核，网络文化产品及服务的内容审核由2名以上审核人员实施,审核人员填写审核意见并签字后，报本单位内容管理负责人复核签字。我单位通过技术手段对网站
              (平台)运行的产品及服务的内容进行实时监管,发现违规内容的要立即停止提供，保存有关记录,内容审核记录的保存期不少于2年，重大问题向所在地省级文化行政部门报告。
            </p>
            <p>具体操作：</p>
            <p>(1)设立自审信息安全小组。</p>
            <p>
              (2)信息安全小组负责对单位所有网络资源进行实时监控，做到及时发现、
              即时处理的原则办理,并对处理结果备案,对重大有害信息事件，应在第一时间上报主管领导及相关部门。
            </p>
            <p>
              (3)信息安全小组负责界定、监控、受理有害信息事件,要做到即接快办，夜间、节假日值班期间接到、发现的，应于次日或节假日后的第一个工作日办理，对需紧急办理的重大信息安全事件可先处理后登记
              (如遇紧急情况，可直接关闭服务器等设备，暂停网络运行)。
            </p>
            <p>
              (4)负责查办的相关人员接到交办的事件后,应及时安排办理，要求在最短时限内处理完毕，如遇特殊情况不能按时处理完毕的，应报主管领导说明情况，可适当延长处理时间，处理结果应及时反馈给信息安全小组组长。在处理有害信息事件时，应按照处理流程，及时填写相应表单,并随处理结果报告一并存档。
            </p>
            <p>
              (5)处理人员应对重大有害信息时间的举报人、发现人要求保密者做到保密，有关重大的有害信息事件及处理过程不得泄密。
            </p>
            <p>自审流程图 :</p>
            <img src="../assets/relevant-notice-image.png" />
          </div>

          <div v-else-if="active === '防沉迷'">
            <p>
              为保护未成年人身心健康，预防其过度使用网络，根据《中华人民共和国未成年人保护法》、国家网信办《移动互联网应用程序信息服务管理规定》及相关法律法规，结合“乐龄听书”App的产品特性，特制定本机制。本机制旨在通过系统性的技术与管理措施，合理限制未成年人的使用行为。
            </p>
            <p>
              具体而言，我们将对识别出的未成年人用户账号实施以下核心保护措施：严格限制其每日累计使用时长，其中未满16周岁的用户每日不得超过1小时，16周岁以上未满18周岁的用户每日不得超过2小时。当用户连续使用超过30分钟时，系统将自动弹出提示，建议其休息。同时，为保障夜间休息，每日晚22时至次日早6时，所有未成年人账号的服务将暂停使用。为实现有效管理，本App在注册、登录及主要消费环节设有实名认证要求，并采用必要的技术手段（如验证码、密码）防止未成年人绕过防沉迷限制。此外，我们还将建立适合未成年人的专属内容池，推荐适龄的有声内容，以营造健康、安全的网络使用环境。
            </p>
          </div>

          <div v-else-if="active === '家长监护'">
            <p>
              根据《中华人民共和国未成年人保护法》、《未成年人网络保护条例》等相关法律法规，我们特提供以下指引。
            </p>
            <p class="text-bold paragraph">1. 善用设备系统级管控工具</p>
            <p>
              建议您优先使用孩子所用智能手机或平板电脑操作系统自带的“家长控制”或“屏幕使用时间”功能（如iOS的“屏幕使用时间”、安卓系统的“数字健康”或相关品牌手机的“儿童空间”）。通过这些系统工具，您可以：
            </p>
            <p>为孩子的设备设置整体使用时长限制或停用时间。</p>
            <p>限制特定应用（包括“乐龄听书”App）的每日可使用时间。</p>
            <p>管理应用安装与内容访问权限。</p>
            <p class="text-bold paragraph">2. 建立明确的家庭使用约定</p>
            <p>
              与技术管控相结合，我们强烈建议您与孩子进行开诚布公的沟通，共同制定并遵守家庭网络使用规则，例如：
            </p>
            <p>
              明确使用时段：约定每日或每周可使用“乐龄听书”App的具体时间段（如完成作业后、周末午后），并避开夜间休息时间。
            </p>
            <p>
              约定使用场景：明确听书是一种休闲或学习辅助活动，不应影响正常的学业、阅读、睡眠和家庭互动。
            </p>
            <p>
              鼓励内容分享：定期与孩子交流收听的内容，了解他们的兴趣，并引导他们选择有益身心的音频节目。
            </p>
            <p class="text-bold paragraph">3. 了解并利用App的现有基础功能</p>
            <p>您可以通过查看孩子设备上“乐龄听书”App内的记录，辅助了解其使用情况：</p>
            <p>
              查阅收听历史：该应用通常具备“收听历史”功能，您可以在“我的”页面查看最近的播放记录，了解孩子关注的内容类型。
            </p>
            <p>
              关注内容安全：“乐龄听书”内容多来源于专业出版机构，但作为监护人，您仍有责任关注其总体健康性。若发现任何认为不适宜未成年人的内容，可通过App内的反馈渠道进行反映。
            </p>
            <p class="text-bold paragraph">
              4. 考虑使用替代或辅助方案 如果您对监护功能有较强需求，可以考虑：
            </p>
            <p>选择具备完善青少年模式的综合性音频平台作为替代。</p>
            <p>使用第三方家庭安全类软件，这类软件通常提供跨应用的更全面使用行为管理。</p>
            <p>
              作为监护人，您是保护孩子免受网络沉迷影响的第一责任人。在相关应用未提供专门监护工具的情况下，主动利用现有技术手段、结合积极的家庭教育与沟通，是当前最有效的监护途径。我们希望本指引能为您提供切实帮助。
            </p>
          </div>

          <div v-else-if="active === '纠纷处理'">
            <p class="text-bold paragraph">一、纠纷解决渠道</p>
            <p class="text-bold">1. 在线自助解决</p>
            <p>帮助中心：App内“我的-帮助与反馈”提供常见问题解答</p>
            <p>智能客服：24小时在线，快速响应高频问题</p>
            <p>反馈表单：详细描述问题，我们将于24小时内初步响应</p>
            <p class="text-bold paragraph">2. 人工客服通道</p>
            <p>服务时间：每日8:00-22:00（工作日周一至周五）</p>
            <p>联系电话：0551-63490391（老年用户专线，语音清晰简洁）</p>
            <p class="text-bold paragraph">3. 书面提交渠道</p>
            <p>电子邮件：894438425@qq.com</p>
            <p>传统信件：合肥市蜀山区祁门路1119号安徽出版大厦9-10层</p>
            <p>
              注：针对不擅长使用智能手机的老年用户，我们特别保留传统信件通道，并承诺15个工作日内书面回复
            </p>

            <p class="text-bold paragraph">二、纠纷处理流程</p>
            <p class="text-bold">第一步：问题受理</p>
            <p>- 收到您的反馈后，1个工作日内确认受理并分配专属客服</p>
            <p>- 简单问题：24小时内解决</p>
            <p>- 复杂问题：48小时内给出解决方案或处理时间表</p>
            <p class="text-bold paragraph">第二步：调查核实</p>
            <p>- 我们的客服团队将全面调查问题原因</p>
            <p>- 必要时与第三方服务商（如支付平台、内容提供商）协调</p>
            <p>- 全程向您通报进展，绝不推诿拖延</p>
            <p class="text-bold paragraph">第三步：解决方案</p>
            <p>- 提供明确解决方案及执行时间</p>
            <p>- 如属我方责任，将根据情况提供：功能修复、服务补偿、会员延期或退款等</p>
            <p>- 与您确认方案是否满意，确保问题真正解决</p>
            <p class="text-bold paragraph">第四步：回访与改进</p>
            <p>- 问题解决后3日内进行回访</p>
            <p>- 将您的建议纳入产品改进计划</p>
            <p>- 定期公开典型纠纷案例及处理结果（隐去个人信息）</p>
            <p class="text-bold paragraph">三、特殊关怀政策（针对60岁以上用户）</p>
            <p>1. 优先通道：60岁以上用户纠纷自动升级优先处理</p>
            <p>2. 简化流程：提供“一键求助”服务，子女可远程协助提交</p>
            <p>3. 上门服务：在主要城市，为行动不便的老年用户提供预约上门协助（需提前预约）</p>
            <p>4. 大字体指引：提供专门的大字体版纠纷处理指南</p>
            <p class="text-bold paragraph">四、无法解决的争议</p>
            <p>如双方协商无法达成一致，我们承诺：</p>
            <p>1. 提供完整的沟通记录和我们的解决方案说明</p>
            <p>2. 尊重并配合第三方调解机构、消费者协会或监管部门的调查与调解</p>
            <p>3. 按照法律规定，接受仲裁或司法裁决</p>
            <p class="text-bold paragraph">五、我们的保证</p>
            <p>1. 绝不泄露：您的个人信息和纠纷内容将严格保密</p>
            <p>2. 绝不收费：纠纷处理全程不收取任何费用</p>
            <p>3. 绝不推诿：实行“首问负责制”，第一位接待您的客服将负责跟进至问题解决</p>
            <p>4. 持续改进：每月分析纠纷数据，优化产品与服务</p>
            <p class="paragraph">乐龄听书，用心倾听每一个声音</p>
            <p>
              我们深知信任的建立需要时间，而破坏只需一瞬间。因此，我们珍视您的每一次反馈，无论是表扬还是批评，都是我们进步的动力。让我们共同营造一个更友善、更贴心的数字听书环境。
            </p>
            <p class="paragraph">最后更新日期：2026年1月</p>
            <p>本政策最终解释权归乐龄听书所有，如有变动将通过App通知、短信等方式告知用户</p>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Head from './index/Head';
import Navbar from './index/Navbar.vue';
import Banner from './index/Banner';
import Footer from './index/Footer';

export default {
  name: 'Contact',
  components: {
    Head,
    Navbar,
    Banner,
    Footer,
  },
  props: {},
  data() {
    return {
      menus: ['自审制度', '防沉迷', '家长监护', '纠纷处理'],

      active: '自审制度',
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.main {
  width: 100%;
  // height:1000px;
  background-color: white;
  overflow: hidden;
}

.container {
  width: 1200px;
  // height:1000px;
  // background-color: pink;
  margin: 0 auto;
  overflow: hidden;
  text-align: center;
  margin-bottom: 90px;
  display: flex;
}

.menu {
  width: 150px;

  .menu-item {
    width: 100%;
    height: 50px;
    font-size: 16px;
    color: #4b4b4b;
    background: #efefef;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .menu-item:hover,
  .menu-item_active {
    color: #ffffff;
    background: #0067ac;
  }
}

.content {
  flex: 1;

  .title {
    font-size: 20px;
    color: #333333;
    font-weight: bold;
    text-align: center;
    margin: 30px 0;
  }

  p {
    width: 800px;
    line-height: 24px;
    text-align: left;
    margin: 0 auto;
  }

  table {
    width: 800px;
    color: #3d3d3d;
    font-size: 14px;
    margin: 0 auto;
  }

  .text-bold {
    font-weight: bold;
  }

  .paragraph {
    margin-top: 20px;
  }
}
</style>
